import React, { Component } from "react";
import PropTypes from "prop-types";
import GoogleAnalytics from "react-ga";
import { isCordovaApp } from "./cordovaUtils";

const GA_ID = process.env.REACT_APP_GA_ID;
const GA_IDS = [GA_ID];
let NUM_OF_TRACKERS = 0;
let isInit = false;
let isCustomGAIdAdded = false;
let GA_DOMAIN = "unconfigured.global.bible";

const generateGAStorageKey = () =>
  `${Math.random()
    .toString(36)
    .substr(2, 8)}-${Math.random()
    .toString(36)
    .substr(2, 4)}-${Math.random()
    .toString(36)
    .substr(2, 4)}-${Math.random()
    .toString(36)
    .substr(2, 12)}`;

const createGAOptions = (gaLocalStorageKey, index) => {
  /* Tracker name is the current index in the GA_IDS array */
  const gaOptions = {
    storage: "none",
    clientId: window.localStorage.getItem(gaLocalStorageKey + index),
    name: index
  };
  return gaOptions;
};

/* ***************************************************************************** */
/*    Google Analytics can be reinitalized by passing in an array of additional  */
/*    GA Id numbers. There is no need to inlcude the default GA Id, it will      */
/*    always be automatilyc included ex:                                         */
/* ***************************************************************************** */

const initWithIds = () => {
  const promise = new Promise((resolve, reject) => {
    if (isInit) return resolve();
    isInit = true;

    if (isCordovaApp && window) {
      const GA_LOCAL_STORAGE_KEY = generateGAStorageKey();
      const gaIds = GA_IDS.map((id, index) => ({
        trackingId: id,
        gaOptions: createGAOptions(GA_LOCAL_STORAGE_KEY, index.toString())
      }));
      GoogleAnalytics.initialize(gaIds);
      gaIds.forEach((gaObj, index) => {
        GoogleAnalytics.ga(tracker => {
          window.localStorage.setItem(
            GA_LOCAL_STORAGE_KEY + index,
            tracker.get(GA_LOCAL_STORAGE_KEY + index)
          );
        });
        GoogleAnalytics.ga(`${index}.set`, "checkProtocolTask", () => {});
      });
      NUM_OF_TRACKERS = gaIds.length;
    } else {
      const gaIds = GA_IDS.map((id, index) => ({
        trackingId: id,
        gaOptions: { name: index.toString() } // set tracker name to the current index in the GA_IDS array
      }));
      GoogleAnalytics.initialize(gaIds);
      NUM_OF_TRACKERS = gaIds.length;
    }
    return resolve();
  });
  return promise;
};

export const addCustomGAId = gaIds => {
  if (!isCustomGAIdAdded) {
    isCustomGAIdAdded = true;
    gaIds.forEach(gaId => {
      console.log("adding custom gaId: ", gaId);
      return GA_IDS.push(gaId);
    });
  }
};

export const setGADomain = subdomain => {
  GA_DOMAIN = `${subdomain}.global.bible`;
};

/* Google Analytics is first initalized here on load of library. */
// initWithIds();

const withTracker = WrappedComponent => {
  const trackPage = (page, options = {}) => {
    const recordPageview = () => {
      /* All tracker names are the values from 0 to NUM_OF_TRACKERS - 1 */
      const trackerNames = [...new Array(NUM_OF_TRACKERS).keys()];
      GoogleAnalytics.set(
        {
          page,
          hostname: GA_DOMAIN,
          ...options
        },
        trackerNames
      );
      GoogleAnalytics.pageview(page, trackerNames);
    };

    if (!isInit) {
      initWithIds().then(recordPageview);
    } else {
      recordPageview();
    }
  };

  const HOC = class extends Component {
    static propTypes = {
      location: PropTypes.shape({
        pathname: PropTypes.string.isRequired
      }).isRequired
    };

    // respond to initial page load
    componentDidMount() {
      const page = this.props.location.pathname;
      const options = {};
      if (this.props.bible)
        options.dimension1 = this.props.bible.currentBibleId;
      trackPage(page, options);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      const currentPage = this.props.location.pathname;
      const nextPage = nextProps.location.pathname;
      const currentQueryString = this.props.location.search;
      const nextQueryString = nextProps.location.search;

      // Respond to page navigation or query string change
      if (currentPage !== nextPage || currentQueryString !== nextQueryString) {
        const options = {};
        if (nextProps.match)
          options.dimension1 = nextProps.match.params.bibleId;
        trackPage(nextPage, options);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  return HOC;
};

export default withTracker;
